import type { ApiCallback } from '@disy/lib/single-execution';
import { singleExecution } from '@disy/lib/single-execution';

import { BackendAbortController } from './backend-abort-controller/backend-abort-controller';

/** Convenience wrapper around {@link singleExecution} that uses a {@link BackendAbortController} to abort a request. */
export function backendSingleExecution<T>(apiCallback: ApiCallback<T>, cancelTimeout = 0) {
  return singleExecution(apiCallback, () => new BackendAbortController(), cancelTimeout);
}
